<div class="flex relative">
    <div class="min-h-checkbox min-w-checkbox w-checkbox h-checkbox relative mr-xs" #checkboxContainer>
        <input
            [id]="inputId"
            type="checkbox"
            [checked]="checked"
            [name]="name"
            [disabled]="disabled"
            (change)="handleChange($event)"
            [ngClass]="{
                'cursor-pointer': !disabled
            }"
            class="absolute w-full h-full peer left-0 m-0 z-30 opacity-0"
            [attr.aria-label]="ariaLabel ? ariaLabel : null"
            [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : labelId"
            [attr.aria-checked]="checked" />
        <! -- Do not show checkbox if the checkbox is not clicked. only show it if it is clicked -->

        <div
            [ngClass]="{
                'outline outline-2 outline-checkbox-error': invalid
            }"
            class="absolute z-20 left-0 right-0 top-0 bottom-0 border border-solid border-checkbox-border hover:after:scale-[2.0] peer-hover:after:scale-[2.0] peer-focus:outline peer-focus:outline-2 peer-focus:outline-checkbox-focus peer-disabled:opacity-50 peer-checked:hidden"></div>
        <div
            [ngClass]="{
                'outline outline-2 outline-checkbox-error': invalid
            }"
            class="absolute justify-center items-center z-20 left-0 right-0 top-0 bottom-0 border border-solid border-checkbox-border hover:after:scale-[2.0] hidden peer-hover:after:scale-[2.0] peer-focus:outline peer-focus:outline-2 peer-focus:outline-checkbox-focus peer-disabled:opacity-50 peer-checked:flex peer-checked:bg-checkbox-fill peer-checked:border-none">
            <span porIcon color="white" [width]="icon.width" [height]="icon.height" [icon]="$any(icon.name)" class="text-white"></span>
        </div>
        <! -- Circle hover, only seen with material -->
        <div
            [ngClass]="{
                'peer-hover:scale-[1.8]': !disabled
            }"
            class="z-10 content-[''] absolute w-full h-full top-0 opacity-0 bg-radio-shadow rounded-radio scale-[0] peer-focus:scale-[1.8] peer-hover:opacity-100 transition-all"></div>
    </div>
    <label class="flex items-center font-roboto text-checkbox font-medium text-text-base" [for]="inputId" [id]="labelId" [ngClass]="{ 'opacity-50': disabled }">
        <ng-content></ng-content>
    </label>
</div>
